module.exports = __webpack_public_path__ + "img/6.542b8a12.png";